import React from 'react';
import glamorous from 'glamorous';

import mediaQueries from "../../../styles/media-queries";

const FlexList = glamorous.ul({
  listStyleType: "none",
  padding: "0",
  marginBottom: "32px",
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "space-around",
  [mediaQueries.tablet]: {
    justifyContent: "flex-start",
    marginLeft: "-5px", // offset the margin on each image
    marginRight: "-5px"
  }
});

export default (props) => (
  <FlexList>
    {props.children}
  </FlexList>
);



// WEBPACK FOOTER //
// ./src/components/areas/Background/List.js